enum DispatchedEvents {
	CAMPAIGN_EDITOR_READY_TO_LOAD_GEOTARGETING = 'campaign_editor_ready_to_load_geotargeting',
	GEOTARGETING_MICROSERVICE_LOADED = 'geotargeting_microservice_loaded',
	GEOTARGETING_SAVED = 'geotargeting_saved',
	GEOTARGETING_START_UP = 'geotargeting_start_up'
}

export { DispatchedEvents }
